import { ThemeProvider, ThemeContext } from "./context/Themes";
import { LoaderProvider } from "./context/Preloader";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { getTheme } from './theme';
import { Error } from "./pages/supports";
import {
  Avatars,
  Alerts,
  Buttons,
  Charts,
  Tables,
  Fields,
  Headings,
  Colors,
} from "./pages/blocks";
import {
  Ecommerce,
  Analytics,
  CRM,
  ForgotPassword,
  ResetPassword,
  Register,
  Login,
  UserProfile,
  MyAccount,
  ProductView,
  ProductUpload,
  InvoiceList,
  InvoiceDetails,
  OrderList,
  Message,
  Notification,
  BlankPage,
  Settings,
} from "./pages/master";

import { useState, useEffect, useContext } from "react";
import axios from "axios";
import UsersList from "./pages/master/Users/UsersList";
import AddPlan from "./pages/master/Plans/AddPlan";
import PlanList from "./pages/master/Plans/PlanList";
import EditPlan from "./pages/master/Plans/EditPlan";
import AddService from "./pages/master/Link Store/AddService";
import ServicesList from "./pages/master/Link Store/ServicesList";
import EditService from "./pages/master/Link Store/EditService";
import AddCategory from "./pages/master/Product Categories/AddCategory";
import CategoryList from "./pages/master/Product Categories/CategoryList";
import AddProduct from "./pages/master/Products/AddProduct";
import ProductList from "./pages/master/Products/ProductList";
import EditProduct from "./pages/master/Products/EditProduct";
import AddCoupon from "./pages/master/Coupons/AddCoupon";
import CouponsList from "./pages/master/Coupons/CouponsList";
import EditCoupon from "./pages/master/Coupons/EditCoupon";
import TeamsList from "./pages/master/Teams/TeamsList";
import AddUser from "./pages/master/Users/AddUser";
import EditUser from "./pages/master/Users/EditUser";
import StorehouseList from "./pages/master/Storehouse/StorehouseList";
import AddStorehouse from "./pages/master/Storehouse/AddStorehouse";
import EditStorehouse from "./pages/master/Storehouse/EditStorehouse";
import TabList from "./pages/master/Tabs/TabList";
import AddTab from "./pages/master/Tabs/AddTab";
import EditTab from "./pages/master/Tabs/EditTab";
import QuadrantList from "./pages/master/Quadrant/QuadrantList";
import AddQuadrant from "./pages/master/Quadrant/AddQuadrant";
import EditQuadrant from "./pages/master/Quadrant/EditQuadrant";
import FilterList from "./pages/master/Filter/FilterList";
import AddFilter from "./pages/master/Filter/AddFilter";
import EditFilter from "./pages/master/Filter/EditFilter";
import ItemList from "./pages/master/Item/ItemList";
import AddItem from "./pages/master/Item/AddItem";
import EditItem from "./pages/master/Item/EditItem";
import JobsList from "./pages/master/Job/JobsList";
import AddJob from "./pages/master/Job/AddJob";
import EditJob from "./pages/master/Job/EditJob";
import OrderBuilder from "./pages/master/Order/OrderBuilder";
import OrdersList from "./pages/master/Order/OrdersList";
import CompanyList from "./pages/master/Company/CompanyList";

// MUI Theme wrapper that syncs with existing theme context
const MuiThemeWrapper = ({ children }) => {
  const { theme } = useContext(ThemeContext);
  const muiTheme = getTheme(theme);

  return (
    <MuiThemeProvider theme={muiTheme}>
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  );
};

export default function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isCheckingAuth, setIsCheckingAuth] = useState(true);

useEffect(() => {
    const verifyToken = async () => {
      const token = localStorage.getItem("token");
      
      if (!token) {
        setIsLoggedIn(false);
        setIsCheckingAuth(false);
        return;
      }

      try {
        await axios.get(`${process.env.REACT_APP_BASE_URL}admin/check-token`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setIsLoggedIn(true);
      } catch (error) {
        console.error("Token verification failed:", error);
        localStorage.clear();
        setIsLoggedIn(false);
      } finally {
        setIsCheckingAuth(false);
      }
    };

    verifyToken();
  }, []);

  if (isCheckingAuth) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#f5f5f5'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{
            border: '4px solid #f3f3f3',
            borderTop: '4px solid #3498db',
            borderRadius: '50%',
            width: '50px',
            height: '50px',
            animation: 'spin 1s linear infinite',
            margin: '0 auto 20px'
          }}></div>
          <p style={{ color: '#666', fontSize: '16px' }}>Loading...</p>
          <style>{`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}</style>
        </div>
      </div>
    );
  }

  return (
    <ThemeProvider>
      <MuiThemeWrapper>
        <LoaderProvider>
          <BrowserRouter>
            <Routes>
            {/* master Pages */}
            {/* <Route path="/ecommerce" element={<Ecommerce /> } /> */}
            {/* <Route path="/analytics" element={<Analytics /> } />
                        <Route path="/crm" element={<CRM /> } />
                        <Route path="/login" element={<Login />} />
                        <Route path="/register" element={<Register />} />
                        <Route path="/forgot-password" element={<ForgotPassword />} />
                        <Route path="/user-list" element={<UserList />} />
                        <Route path="/user-profile" element={<UserProfile />} />
                        <Route path="/my-account" element={<MyAccount />} />
                        <Route path="/product-list" element={<ProductList />} />
                        <Route path="/product-view" element={<ProductView />} />
                        <Route path="/product-upload" element={<ProductUpload />} />
                        <Route path="/invoice-list" element={<InvoiceList />} />
                        <Route path="/invoice-details" element={<InvoiceDetails />} />
                        <Route path="/order-list" element={<OrderList />} />
                        <Route path="/message" element={<Message />} />
                        <Route path="/notification" element={<Notification />} />
                        <Route path="/settings" element={<Settings />} />
                        <Route path="/blank-page" element={<BlankPage />} /> */}

            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />

            {/* Blocks Pages */}
            <Route path="/headings" element={<Headings />} />
            <Route path="/buttons" element={<Buttons />} />
            <Route path="/avatars" element={<Avatars />} />
            <Route path="/colors" element={<Colors />} />
            <Route path="/charts" element={<Charts />} />
            <Route path="/tables" element={<Tables />} />
            <Route path="/fields" element={<Fields />} />
            <Route path="/alerts" element={<Alerts />} />
            {isLoggedIn && (
              <>
                {/* Company Routes (Master Admin Only) */}
                <Route path="/company-list" element={<CompanyList />} />
                {/* Company Routes */}

                {/* User Routes */}
                <Route path="/users-list" element={<UsersList />} />
                <Route path="/add-user" element={<AddUser />} />
                <Route path="/edit-user/:id" element={<EditUser />} />
                {/* User Routes */}

                {/* Storehouse Routes */}
                <Route path="/storehouse-list" element={<StorehouseList />} />
                <Route path="/add-storehouse" element={<AddStorehouse />} />
                <Route
                  path="/edit-storehouse/:id"
                  element={<EditStorehouse />}
                />
                {/* Storehouse Routes */}

                {/* Tab Routes */}
                <Route path="/tab-list" element={<TabList />} />
                <Route path="/add-tab" element={<AddTab />} />
                <Route path="/edit-tab/:id" element={<EditTab />} />
                {/* Tab Routes */}

                {/* Quadrant Routes */}
                <Route path="/quadrant-list" element={<QuadrantList />} />
                <Route path="/add-quadrant" element={<AddQuadrant />} />
                <Route path="/edit-quadrant/:id" element={<EditQuadrant />} />
                {/* Quadrant Routes */}

                {/* Filter Routes */}
                <Route path="/filter-list" element={<FilterList />} />
                <Route path="/add-filter" element={<AddFilter />} />
                <Route path="/edit-filter/:id" element={<EditFilter />} />
                {/* Filter Routes */}

                {/* Job Routes */}
                <Route path="/jobs-list" element={<JobsList />} />
                <Route path="/add-job" element={<AddJob />} />
                <Route path="/edit-job/:id" element={<EditJob />} />
                {/* Job Routes */}

                {/* Order Routes */}
                <Route path="/order-builder" element={<OrderBuilder />} />
                <Route path="/order-list" element={<OrdersList />} />
                {/* Order Routes */}

                {/* Item Routes */}
                <Route path="/items-list" element={<ItemList />} />
                <Route path="/add-item" element={<AddItem />} />
                <Route path="/add-master-item" element={<AddItem />} />
                <Route path="/edit-item/:id" element={<EditItem />} />
                <Route path="/edit-master-item/:id" element={<EditItem />} />
                {/* Item Routes */}
              </>
            )}

            {/* Supports Pages */}
            <Route path="*" element={<Error />} />

            {/*isLoggedIn ? (
              <Route path="/" element={<Ecommerce />} />
            ) : (
              <Route path="/" element={<Login />} />
            )*/}
            <Route path="/" element={isLoggedIn ? <Ecommerce /> : <Login />} />


            </Routes>
          </BrowserRouter>
        </LoaderProvider>
      </MuiThemeWrapper>
    </ThemeProvider>
  );
}
